
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import * as XLSX from "xlsx";
import DosyaFiltrelemeCard, {ListelemeTuru} from "@/components/eicrapro/DosyaFiltrelemeCard.vue";
import ExcelYuklemeCard from "@/components/eicrapro/ExcelYuklemeCard.vue";
import TakipTabloFiltre from "@/components/eicrapro/TakipTabloFiltre.vue";
import {
  GorunurTakipSonucu,
  hesaplaGorunurTakipler,
  kesistir,
  TakipTabloFiltreEntity
} from "@/components/forms/form-wizard/eicrapro/genelIslemTakipFiltre";
import {AvukatIcraDosyalariTalep} from "@/plugins/uyap-plugin/uyap/AvukatIcraDosyalari";
import {MahkemeBirimleriRow} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import {SenkronPlanDosya} from "@/services/senkronPlanService";
import {AZAMI_DOSYA_UYARI_ESIGI, dosyaSayisiAsimMesaji} from "@/services/senkronPlanGovde";
import {
  anahtarBazliTekillestir,
  avukatDosyalariniPlanaCevir,
  dosyaAnahtari,
  dosyalariBirlestir,
  dosyaSayisiAsildiMi,
  tumunuSecUygula,
  tumuSecildiMi
} from "@/components/eicrapro/senkron/senkronDosyaSecimi";
import {
  excelDogrula,
  excelSatirlariniCozumle
} from "@/components/eicrapro/senkron/excelDosyaCozumleme";

/**
 * Plana dosya ekleme sihirbazı (Faz 3, DEV-2966 — manuel test düzeltmesi).
 *
 * ÖNCEKİ AKIŞ NEDEN DEĞİŞTİ: sekmeli tasarımda kullanıcı tabloda seçim yapıp
 * "Dosyaları Kullan"a basıyordu ama hiçbir şey olmuyordu — önce "Seçilenleri
 * Plana Ekle", SONRA "Dosyaları Kullan" gerekiyordu. İki aşamalı bu ayrım
 * manuel testte kafa karıştırdı. Artık repodaki sihirbaz alışkanlığıyla
 * (v-stepper) tek yönlü bir akış var: Listele → Seç → Özet ve Onay; "Tamam"
 * tek tıkla bitiriyor, ara "kullan/ekle" ayrımı yok.
 *
 * ELLE GİRİŞ KALDIRILDI: kullanıcılar birim kimliğini bilmiyor. Yerine repodaki
 * yerleşik Excel deseni geldi (`ExcelYuklemeCard` + daire adı → `birim_id`
 * çözümü). Plana yazılan değer değişmedi: `birim_id` + `dosya_esas_no`; volatil
 * `dosyaId` yine taşınmıyor.
 */
@Component({
  components: {DosyaFiltrelemeCard, ExcelYuklemeCard, TakipTabloFiltre}
})
export default class SenkronDosyaSecDialog extends Vue {
  @Prop({default: false}) value!: boolean;
  /** Planda HÂLİHAZIRDA duran dosyalar; özet "zaten planda"yı buna göre sayar. */
  @Prop({default: () => []}) dosyalar!: Array<SenkronPlanDosya>;

  adim = 1;
  azamiDosya = AZAMI_DOSYA_UYARI_ESIGI;

  /** `DosyaFiltrelemeCard`ın beklediği alanlar; sihirbazın `TakipFiltreEntity`si ile aynı şekil. */
  filtre: any = SenkronDosyaSecDialog.bosFiltre();
  excelDosyasi: File | null = null;
  tabloFiltre: TakipTabloFiltreEntity = new TakipTabloFiltreEntity();

  takipler: Array<any> = [];
  secilenTakipler: Array<any> = [];
  listeleniyor = false;
  listelemeHatasi = "";

  /** UYAP daire listesi — Excel'deki daire adını `birim_id`ye çözmek için. */
  icraDaireleri: Array<MahkemeBirimleriRow> = [];

  basliklar = [
    {text: "Birim", value: "birimAdi"},
    {text: "Esas No", value: "dosyaNo"},
    {text: "Durum", value: "dosyaDurum"}
  ];

  static bosFiltre() {
    return {
      dosyaKapaliMi: 0,
      yargiTuru: 2,
      yargiBirimi: "1101",
      listeleme_turu: 1,
      dosyaYil: undefined,
      dosyaSira: undefined,
      dosyaSira2: undefined,
      baslangicTarihi: "",
      bitisTarihi: "",
      tcKimlikNo: "",
      adi: "",
      soyadi: "",
      kurumAdi: "",
      mersisNo: "",
      vergiNo: ""
    };
  }

  get acik(): boolean {
    return this.value;
  }

  set acik(deger: boolean) {
    this.$emit("input", deger);
  }

  get adimAdi(): string {
    return ["Listele", "Seç", "Özet ve Onay"][this.adim - 1] ?? "";
  }

  get uyapBagli(): boolean {
    return this.$store.getters.isUyapConnected === true;
  }

  get gorunurSonuc(): GorunurTakipSonucu {
    return hesaplaGorunurTakipler(this.takipler, this.tabloFiltre);
  }

  get gorunurTakipler(): Array<any> {
    return this.gorunurSonuc.satirlar;
  }

  get gorunurSeciliSayisi(): number {
    return kesistir(this.secilenTakipler, this.gorunurTakipler).length;
  }

  get gizliSeciliSayisi(): number {
    return this.secilenTakipler.length - this.gorunurSeciliSayisi;
  }

  get tumuSeciliMi(): boolean {
    return tumuSecildiMi(this.secilenTakipler, this.gorunurTakipler);
  }

  /** Filtreye giren TÜM satırları seçer/bırakır — yalnız görünen sayfayı değil. */
  tumunuSec() {
    this.secilenTakipler = tumunuSecUygula(this.secilenTakipler, this.gorunurTakipler);
  }

  /** Planda zaten duran dosyaların anahtar kümesi. */
  get mevcutAnahtarlar(): Record<string, boolean> {
    const kume: Record<string, boolean> = {};
    (this.dosyalar ?? []).forEach((dosya) => {
      kume[dosyaAnahtari(dosya)] = true;
    });
    return kume;
  }

  get ozetSatirlari(): Array<any> {
    // Satır satır çevrilir, TOPLU çevirinin çıktısı indeksle eşlenmez:
    // avukatDosyalariniPlanaCevir eksik satırları ELİYOR, dolayısıyla çıktı
    // indeksi kaynak indeksiyle kayabilir ve yanlış satıra yanlış ad yazılırdı.
    const satirlar: Array<any> = [];

    this.secilenTakipler.forEach((kaynak: any) => {
      const cevrilen = avukatDosyalariniPlanaCevir([kaynak]);
      if (!cevrilen.length) return;

      const dosya = cevrilen[0];
      const anahtar = dosyaAnahtari(dosya);
      const yazilan = (kaynak?.birimAdi ?? "").trim();

      satirlar.push({
        anahtar,
        birimAdi: dosya.birim_adi || "—",
        // Excel'de yazılan ad çözülenden farklıysa kullanıcı son kontrolü
        // kaydetmeden ÖNCE yapabilsin.
        yazilanAd: yazilan && yazilan !== dosya.birim_adi ? yazilan : "",
        dosyaEsasNo: dosya.dosya_esas_no,
        zatenPlanda: this.mevcutAnahtarlar[anahtar] === true
      });
    });

    // Excel'de ya da UYAP listelemesinde AYNI dosya (aynı dosyaAnahtari) birden
    // çok satırda gelebiliyor. Tekilleştirilmeden sayılırsa eklenecekSayisi
    // (ve dolayısıyla toplamSonrasi/toplamAsildi) mükerrer satırları da
    // ekleniyor sayıp geçerli bir planı 500 tavanına takılıyormuş gibi
    // gösterebiliyordu (DEV-2603 regresyonu) — dosyalariBirlestir'in
    // paylaştığı `anahtarBazliTekillestir` deseni burada da uygulanır.
    return anahtarBazliTekillestir(satirlar, (satir) => satir.anahtar);
  }

  get eklenecekSayisi(): number {
    return this.ozetSatirlari.filter((satir) => !satir.zatenPlanda).length;
  }

  get zatenPlandaSayisi(): number {
    return this.ozetSatirlari.filter((satir) => satir.zatenPlanda).length;
  }

  get toplamSonrasi(): number {
    return (this.dosyalar?.length ?? 0) + this.eklenecekSayisi;
  }

  get toplamAsildi(): boolean {
    return dosyaSayisiAsildiMi(this.toplamSonrasi, this.azamiDosya);
  }

  /** Adım 3 uyarısının metni — `planGecerliMi()`in Kaydet'te göstereceğiyle AYNI cümle (DEV-2603 B25). */
  get asimMesaji(): string {
    return dosyaSayisiAsimMesaji(this.toplamSonrasi, this.azamiDosya);
  }

  /** Dialog her açıldığında sihirbaz baştan başlar. */
  @Watch("value")
  onAcilis(acik: boolean) {
    if (!acik) return;
    this.adim = 1;
    this.takipler = [];
    this.secilenTakipler = [];
    this.excelDosyasi = null;
    this.listelemeHatasi = "";
    this.tabloFiltre = new TakipTabloFiltreEntity();
    if (this.uyapBagli && this.icraDaireleri.length === 0) this.icraDaireleriniYukle();
  }

  geri() {
    if (this.adim > 1) this.adim -= 1;
  }

  /**
   * UYAP daire listesi — Excel'deki daire adını `birim_id`ye çözmek için ŞART.
   *
   * FİLTREYE BAĞLIDIR ve her Excel yüklemesinde GÜNCEL filtreyle çekilir.
   * "Bir kez çek, dolu ise bir daha çekme" kısayolu sessiz bir tuzak üretiyordu:
   * `MahkemeBirimleri` "açık dosyalarım olan birimler" ile "kapalı dosyalarım
   * olan birimler" için FARKLI kümeler döndürüyor. Kullanıcı "Dosya Durumu"nu
   * "Kapalı"ya çevirip Excel yüklediğinde liste hâlâ açık-dosya kümesi oluyor ve
   * daire adını UYAP'taki yazımıyla birebir girmiş olsa bile "daire tanınmadı"
   * hatası alıyordu — hata mesajı da onu yazım hatası aramaya yönlendiriyordu.
   *
   * Tekrar istek maliyeti yok: `MahkemeBirimleri` cevabı talep parametrelerine
   * göre anahtarlanmış 8 saatlik önbellekte duruyor, filtre değişmediyse ağa
   * çıkılmıyor.
   */
  private async icraDaireleriniYukle() {
    try {
      const cevap = await this.$uyap.MahkemeBirimleri().run({
        yargiTuru: this.filtre.yargiTuru,
        yargiBirimi: this.filtre.yargiBirimi,
        dosyaKapaliMi: this.filtre.dosyaKapaliMi != 0
      });
      this.icraDaireleri = cevap.items ?? [];
    } catch (e) {
      console.error("İcra daireleri yüklenemedi:", e);
      this.icraDaireleri = [];
    }
  }

  async listele() {
    if (this.listeleniyor) return;
    this.listeleniyor = true;
    this.listelemeHatasi = "";
    this.secilenTakipler = [];
    this.takipler = [];
    // Yeni liste, yeni tablo filtresi: önceki listeden kalan filtre yenisini
    // sessizce boşaltabiliyor (sihirbazda DEV-2723 ile düzeltilen davranış).
    this.tabloFiltre = new TakipTabloFiltreEntity();

    try {
      if (this.excelDosyasi) {
        await this.excelListele();
      } else {
        await this.uyapListele();
      }

      if (!this.takipler.length) {
        this.listelemeHatasi = this.excelDosyasi
            ? "Excel dosyasında geçerli satır bulunamadı."
            : "Bu filtreyle dosya bulunamadı.";
        return;
      }
      this.adim = 2;
    } catch (e: any) {
      console.error("Senkron planı dosya listelemesi başarısız:", e);
      this.listelemeHatasi = e?.message || "Dosyalar listelenemedi.";
    } finally {
      this.listeleniyor = false;
    }
  }

  /** Excel yolu: oku → çözümle → doğrula. Tek satır bile bozuksa liste yüklenmez. */
  private async excelListele() {
    // HER ZAMAN güncel filtreyle: kullanıcı "Dosya Durumu"nu değiştirmiş olabilir
    // ve daire kümesi buna göre değişiyor (bkz. icraDaireleriniYukle).
    await this.icraDaireleriniYukle();

    const ham = await this.excelOku(this.excelDosyasi as File);
    const satirlar = excelSatirlariniCozumle(ham, this.icraDaireleri, {
      normalize: (ad: any) => this.$uyapHelper.birimAdiNormalize(ad),
      kanonik: (ad: any) => this.$uyapHelper.birimAdiKanonik(ad)
    });

    const hatalar = excelDogrula(satirlar, this.icraDaireleri.length);
    if (hatalar.length) throw new Error(hatalar.join("\n"));

    this.takipler = satirlar;
    // Excel'den gelen satırlar SEÇİLİ gelir: kullanıcı dosyayı zaten kendisi
    // hazırladı, hepsini tek tek yeniden işaretlemesi anlamsız olurdu.
    this.secilenTakipler = satirlar.slice();
  }

  private excelOku(dosya: File): Promise<Array<any>> {
    return new Promise((cozumle, reddet) => {
      const okuyucu = new FileReader();
      okuyucu.onload = (olay: any) => {
        try {
          const kitap = XLSX.read(olay.target.result, {type: "binary"});
          const sayfa = kitap.Sheets[kitap.SheetNames[0]];
          cozumle(XLSX.utils.sheet_to_json(sayfa, {raw: true, blankrows: false}) as Array<any>);
        } catch (e) {
          reddet(new Error("Excel dosyası okunamadı."));
        }
      };
      okuyucu.onerror = () => reddet(new Error("Excel dosyası okunamadı."));
      okuyucu.readAsBinaryString(dosya);
    });
  }

  /** UYAP listeleme yolu — sihirbazdaki desenin sadeleştirilmiş hâli. */
  private async uyapListele() {
    const cevap = await this.uyapSorgusuKos();
    const satirlar = cevap && Array.isArray(cevap.items) ? cevap.items : [];
    satirlar.forEach((satir: any, sira: number) => {
      satir.index = sira;
      satir.rowOrder = sira;
    });
    this.takipler = satirlar;
  }

  private async uyapSorgusuKos(): Promise<any> {
    const listelemeTuru = this.filtre.listeleme_turu;

    if (listelemeTuru === ListelemeTuru.ICRAPRO_DOSYALARI) {
      return await this.icraproDosyalari();
    }

    const talep = this.talepKur();

    if (listelemeTuru === ListelemeTuru.ESAS_NO_ARALIGI) {
      const yil = this.filtre.dosyaYil || 0;
      const ilk = Number(this.filtre.dosyaSira) || 0;
      const son = this.filtre.dosyaSira2 ? Number(this.filtre.dosyaSira2) : null;
      const enKucuk = son ? Math.min(ilk, son) : ilk;
      const enBuyuk = son ? Math.max(ilk, son) : son;
      return await this.$uyap.AvukatIcraDosyalari().esasNoAraligi(talep, yil, enKucuk, enBuyuk);
    }

    return await this.$uyap.AvukatIcraDosyalari().recursive(talep);
  }

  private talepKur(): AvukatIcraDosyalariTalep {
    const talep = new AvukatIcraDosyalariTalep();
    talep.dosyaDurumKod = this.filtre.dosyaKapaliMi;

    const tur = this.filtre.listeleme_turu;

    if (tur === ListelemeTuru.KISI_ILE_ARAMA) {
      talep.setKisi(this.filtre.adi, this.filtre.soyadi, this.filtre.tcKimlikNo);
    } else if (tur === ListelemeTuru.KURUM_ILE_ARAMA) {
      talep.setKurum(this.filtre.kurumAdi, this.filtre.mersisNo, this.filtre.vergiNo);
    } else if (tur === ListelemeTuru.ACILIS_TARIH_ARALIGI) {
      talep.setAcilisTarihAraligi(this.filtre.baslangicTarihi, this.filtre.bitisTarihi);
    } else if (tur === ListelemeTuru.KAPANIS_TARIH_ARALIGI) {
      talep.setKapanisTarihAraligi(this.filtre.baslangicTarihi, this.filtre.bitisTarihi);
    } else if (tur === ListelemeTuru.SON_1_GUN) {
      this.gunAraligi(talep, 1);
    } else if (tur === ListelemeTuru.SON_1_HAFTA) {
      this.gunAraligi(talep, 7);
    } else if (tur === ListelemeTuru.SON_2_HAFTA) {
      this.gunAraligi(talep, 14);
    } else if (tur === ListelemeTuru.SON_1_AY) {
      const baslangic = new Date();
      baslangic.setMonth(baslangic.getMonth() - 1);
      talep.setAcilisTarihAraligi(baslangic.toISOString(), new Date().toISOString());
    }

    return talep;
  }

  private gunAraligi(talep: AvukatIcraDosyalariTalep, gun: number) {
    const baslangic = new Date();
    baslangic.setDate(baslangic.getDate() - gun);
    talep.setAcilisTarihAraligi(baslangic.toISOString(), new Date().toISOString());
  }

  private async icraproDosyalari(): Promise<any> {
    const cevap = await this.$http.get("/api/v1/uyap-dosya-listele");
    const satirlar = Array.isArray(cevap) ? cevap : (cevap?.data ?? []);
    return {
      items: satirlar.map((takip: any) => ({
        birimAdi: takip.icra_dairesi?.isim,
        dosyaNo: takip.dosya_esas_no,
        // kod inceleme: dosyaId hiçbir tüketicide okunmuyordu (GenelIslemFormWizard.vue'daki
        // aynı eşlemeden kopyalanmış kalıntı); volatil olduğu için de zaten saklanmıyor.
        birimId: String(takip.icra_dairesi_id ?? "")
      }))
    };
  }

  /** Tek tık: seçilenler plana eklenir ve dialog kapanır. */
  tamamla() {
    const yeni = avukatDosyalariniPlanaCevir(this.secilenTakipler);
    this.$emit("secildi", dosyalariBirlestir(this.dosyalar ?? [], yeni));
    this.acik = false;
  }

  kapat() {
    this.acik = false;
  }
}
